module.exports = __webpack_public_path__ + "img/3_gif.bcea1ce9.gif";